export default {
    "_more":"More",

    "add": "New",
    "confirm": "Confirm",
    "detail": "Details",
    "search": "Search",
    "clear": "Clear",
    "empty": "Clear",
    "export": "Export",
    "import": "Import",
    "template": "Import template download",
    "save": "Save",
    "cancel": "Cancel",
    "update": "update",
    "delete": "Delete",
    "pbmsubmit": "Submit",
    "pbmcancle": "Recall",
    "pbmapprove": "Approval",
    "appoint": "Appoint",
    "send": "Send",
    "printpreview": "Print Preview",
    "printdesign": "Print Design",
    "upload": "Upload",
    "reupload": "Re-upload",
    "download": "Download",
    "addRow": "New",
    "delRow": "Delete",
    "copyRow": "Duplicate rows",
    "max": "Maximize",
    "min": "Minimize",
    "copyToEnd": "Paste to end line",
    "copyToHere": "Paste here",
    "organizationChat": "Organization Chat",
    "enable": "Enable",
    "disabled": "Disabled",
    "next": "Next",
    "previous": "Previous",
    "first": "First",
    "last": "Last"
}


// WEBPACK FOOTER //
// ./src/locale/en_US.js